import { stampCartCompany } from './cart_company_guard';

export function remove(id, callback = () => {}) {
  const options = {
    method: 'POST',
    payload: {
      id,
      quantity: 0,
    },
    endpoint: '/cart/change.js',
    callback,
  };

  api_base(options);
}

export function add(id, quantity, sections, callback = () => {}) {
  const options = {
    method: 'POST',
    payload: {
      id,
      quantity,
      sections,
    },
    endpoint: '/cart/add.js',
    callback: (result) => {
      stampCartCompany();
      callback(result);
    },
  };

  api_base(options);
}

export function addItems(items, sections, callback = () => {}) {
  const options = {
    method: 'POST',
    payload: {
      items,
      sections,
    },
    endpoint: '/cart/add.js',
    callback: (result) => {
      stampCartCompany();
      callback(result);
    },
  };

  api_base(options);
}

export function update(id, quantity, callback = () => {}) {
  const options = {
    method: 'POST',
    payload: {
      updates: {
        [id]: quantity,
      },
    },
    endpoint: '/cart/update.js',
    callback,
  };

  api_base(options);
}

export function get(callback = () => {}) {
  const options = {
    method: 'GET',
    endpoint: '/cart.js',
    callback,
  };

  api_base(options);
}

export async function clearCart() {
  const response = await fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error('Failed to clear the cart');
  }
  return await response.json();
}

function api_base(options) {
  const { payload, method, endpoint, callback } = options;
  const myHeaders = new Headers();
  let raw;
  myHeaders.append('Content-Type', 'application/json');

  if (payload) {
    raw = JSON.stringify(payload);
  }

  const requestOptions = {
    method,
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  fetch(endpoint, requestOptions)
    .then((response) => response.text())
    .then((result) => {
      if (result) {
        callback(result);
      }
    })
    .catch((error) => {
      // console.log('error', error);
    });
}
